import { configureStore } from '@reduxjs/toolkit'
import appSlice from './slices/appSlice'
import authSlice from './slices/authSlice'
import portfolioSlice from './slices/portfolioSlice'
import skillsSlice from './slices/skillsSlice'
import profileSlice from './slices/profileSlice'
import contactSlice from './slices/contactSlice'
import notificationSlice from './slices/notificationSlice'
import resumeSlice from './slices/resumeSlice'

export const store = configureStore({
  reducer: {
    app: appSlice,
    auth: authSlice,
    portfolio: portfolioSlice,
    skills: skillsSlice,
    profile: profileSlice,
    contact: contactSlice,
    notifications: notificationSlice,
    resume: resumeSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: import.meta.env.NODE_ENV !== 'production',
})